import { lostAgentsTooltips as ltip } from '../../../../agent-production/agent-movement/constants';
import { getAdditionalTableHeader } from '../agGrid/agGrid';
import { cellRenderers } from '../agGrid/tableViews';

const lostAgentsBreakdown = (id, { colSettings: cs }, shouldShowAdditionalInfo) => ({
    id,
    defaultSort: { colId: ltip.officeName.keyField, sortDir: 'desc' },
    tables: [
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('agentInformation', props),
            children: [
                {
                    col: { ...ltip.agentName, isDisplayed: true },
                    colDef: cs.textSm,
                    cellRenderer: cellRenderers.agentNameLink
                },
                { col: { ...ltip.officeId, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...ltip.officeName, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...ltip.officeStreetName, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.officeCity, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...ltip.officeZipCode, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textXs },
                { col: { ...ltip.agentPhone1, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.agentPhone2, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.agentPhone3, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.agentEmail, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.agentStreetName, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textMd },
                { col: { ...ltip.agentCity, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...ltip.agentZipCode, isDisplayed: shouldShowAdditionalInfo }, colDef: cs.textSm },
                { col: { ...ltip.moveDate, isDisplayed: true }, colDef: cs.dateSm }
            ]
        },
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('beforeMove', props),
            children: [{ col: { ...ltip.volumePreMove, isDisplayed: true }, colDef: cs.numberSmInteger }]
        },
        {
            headerGroupTitle: (props) => getAdditionalTableHeader('afterMove', props),
            children: [
                { col: { ...ltip.daysSinceMove, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...ltip.percentOf365DaysWithOffice, isDisplayed: true }, colDef: cs.numberSmPercentageMultiplier },
                { col: { ...ltip.volumePostMove, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...ltip.volumeYardstick, isDisplayed: true }, colDef: cs.numberMdInteger },
                { col: { ...ltip.volumeDifference, isDisplayed: true }, colDef: cs.numberSmInteger },
                { col: { ...ltip.volumeGrowth, isDisplayed: true }, colDef: cs.numberSmPercentageMultiplier }
            ]
        }
    ]
});

export default lostAgentsBreakdown;
